<template>
    <div>
        <LoadingSpinner v-if="showLoadingSpinner" />
        <FindMyCar
            v-else-if="showFindMyCar"
            :heading="this.heading"
            :registration="this.registration"
            :mileage="this.mileage.toString()"
            v-on:search-vehicle="lookupVehicle"
        />
        <ConfirmYourCar
            v-else-if="showConfirmYourCar"
            v-on:collect-service-plan="collectServicePlan"
        />
        <SelectADealer
            v-else-if="showSelectADealer"
            v-on:collect-pricing="collectPricing"
            v-on:place-updated="handlePlaceUpdated"
        />
        <SelectDateTime
            v-else-if="showSelectDateTime"
            :submitting="submitting"
            v-on:create-booking="createBooking"
        />
        <!--SelectDateTime v-on:collect-manufacturer-update="collectManufacturerUpdate" -->
        <ServiceOptions v-else-if="showServiceOptions" />
        <AdditionalServices v-else-if="showAdditionalServices" />
        <YourSummary v-else-if="showYourSummary" />
        <Confirmation v-else-if="showConfirmation" />
    </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import {
    FindMyCar,
    ConfirmYourCar,
    SelectADealer,
    SelectDateTime,
    ServiceOptions,
    AdditionalServices,
    YourSummary,
    Confirmation
} from "./components/index";
import LoadingSpinner from "./components/LoadingSpinner.vue";
import { customEvent, generateLeadEvent } from '../modules/tracking/AnalyticsEvents';

export default {
    components: {
        LoadingSpinner,
        FindMyCar,
        ConfirmYourCar,
        SelectADealer,
        SelectDateTime,
        ServiceOptions,
        AdditionalServices,
        YourSummary,
        Confirmation,
    },
    data() {
        return {
            loading: false,
            submitting: false,
            mileage: "",
            registration: "",
        };
    },
    props: {
        heading: String,
    },
    computed: {
        ...mapState("Dealers", ["dealers", "selectedDealer"]),
        ...mapState("OSB", ["step", "shortOnlineServiceBooking", "selectedOptions", "pricingData", "selectedVehicle", "otherSelected", "nonFranchiseVehicle", "carNotFound", "brand", "customerAddress", "bookingId", "loginUrl"]),
        ...mapGetters("OSB", ["bookingDetailsFormatted", "vehicleDetailsFormatted", "selectedOptionsArray", "subTotal"]),

        queryParams() {
            return new URLSearchParams(window.location.search);
        },
        showLoadingSpinner() {
            return this.loading && this.shortOnlineServiceBooking;
        },
        showFindMyCar() {
            return this.step === 1 && !this.shortOnlineServiceBooking;
        },
        showConfirmYourCar() {
            return this.step === 2 && !this.shortOnlineServiceBooking;
        },
        showSelectADealer() {
            return this.step === 3 && !this.shortOnlineServiceBooking;
        },
        showSelectDateTime() {
            return this.step === (this.shortOnlineServiceBooking ? 5 : 4);
        },
        showServiceOptions() {
            return this.step === (this.shortOnlineServiceBooking ? 4 : 5);
        },
        showAdditionalServices() {
            return this.step === 6 && !this.shortOnlineServiceBooking;
        },
        showYourSummary() {
            return this.step === 7 && !this.shortOnlineServiceBooking;
        },
        showConfirmation() {
            return this.step === (this.shortOnlineServiceBooking ? 6 : 8);
        },
    },
    methods: {
        ...mapActions("Dealers", ["initializeLocation"]),
        ...mapActions("OSB", [
            "collectManufacturerUpdate",
            "collectPricing",
            "collectServicePlan",
        ]),

        ...mapMutations("Auth", ['setHasAccount', 'setVehicleAdded', 'setAuthenticated']),
        ...mapMutations("Dealers", ["setSelectedDealer"]),
        ...mapMutations("OSB", [
            "enableShortOnlineServiceBooking",
            "incrementStep",
            "setBookingId",
            "setBrand",
            "setCarNotFound",
            "setCustomerAddress",
            "setIsNonFranchiseVehicle",
            "setMileage",
            "setOtherSelected",
            "setRegistration",
            "setSelectedVehicle",
            "setStep",
        ]),

        collectUserVehicleData() {
            const userVehicleId = this.queryParams.get("user_vehicle_id");

            if (!userVehicleId) {
                return;
            }

            axios.get(`/api/osb/user-vehicle/${userVehicleId}`)
                .then((response) => {
                    this.registration = response.data.reg_no;
                    this.mileage = response.data.mileage;

                    if (this.shortOnlineServiceBooking) {
                        this.lookupVehicle({
                            registration: this.registration.toLowerCase().split(" ").join(""),
                            mileage: this.mileage,
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        lookupVehicle(vehicle, validator) {
            this.loading = true;
            axios({
                method: "POST",
                url: "/api/osb/vehicle-data",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: {
                    registration: vehicle.registration,
                    mileage: vehicle.mileage,
                },
            })
                .then((response) => {
                    if (typeof response.data.make == 'undefined' || !response.data.make) {
                        if (validator) {
                            validator.errorResponse({
                                data: { "form": ["Sorry, something has gone wrong. If the problem persists, please contact us"] }
                            });

                            validator.allowInput();
                        }
                        return;
                    }
                    this.setBookingId(response.data.id);
                    this.setSelectedVehicle(response.data);
                    this.setRegistration(response.data.registration);
                    this.setMileage(response.data.mileage);
                    this.collectServicePlan();
                    if (this.shortOnlineServiceBooking) {
                        this.collectPricing();
                    }
                    // this.collectManufacturerUpdate();

                    if (validator) {
                        validator.allowInput();
                    }

                    this.incrementStep();
                    this.loading = false;
                })
                .catch(error => {
                    if (error.response.status == 404 || error.response.status == 400) {
                        this.setBookingId(error.response.data.id);
                        this.setRegistration(this.registration);
                        this.setMileage(this.mileage);
                        this.setCarNotFound(true);
                        this.incrementStep();
                        return;
                    }

                    if (validator) {
                        validator.errorResponse(error);
                    }

                    this.loading = false;
                });
            return false;
        },

        collectLocationData() {
            if (! this.shortOnlineServiceBooking) {
                return;
            }

            const params = new URLSearchParams(window.location.search);
            const locationId = params.get("selected_dealer");
            const dealer = this.dealers.find((dealer) => { return dealer.id == locationId });

            if (dealer) {
                this.setSelectedDealer(dealer);
                this.setStep(3);
            }
        },

        checkIfAuthenticated() {
            return new Promise((resolve, reject) => {
                this.$store.dispatch('Auth/checkAuthenticated')
                    .then(() => {
                        resolve();
                    })
                    .catch(error => {
                        console.error('Authentication error:', error);
                        reject(error);
                    });
            });
        },

        createBooking() {
            const customerData = this.$store.state.CustomerData;
            const formData = new FormData();

            formData.set("title", customerData.title);
            formData.set("first-name", customerData.firstName);
            formData.set("last-name", customerData.lastName);
            formData.set("email", customerData.email);
            formData.set("telephone", customerData.telephone);
            formData.set("location-id", this.selectedDealer.id);
            formData.set("vehicle", JSON.stringify(this.vehicleDetailsFormatted));

            formData.set("booking-id", this.bookingId);
            formData.set("brand", this.brand !== "" ? this.brand : window.brand);
            formData.set("booking-details", JSON.stringify(this.bookingDetailsFormatted));
            formData.set("selected-options", JSON.stringify(this.selectedOptionsArray));
            formData.set("service-name", this.pricingData.service_pricing.name);
            formData.set("sub-total", this.subTotal);
            formData.set("location", this.customerAddress || "");

            this.submitting = true;
            axios
                .post("/api/osb/submit", formData)
                .then((response) => {
                    console.log('Booking created successfully:', response.data);
                    customEvent('OSB', 'Click', 'booking confirmed');
                    generateLeadEvent('osb_booking');
                    this.setVehicleAdded(response.data.vehicle_added)
                    this.setHasAccount(response.data.has_account)

                    this.submitting = false;

                    this.incrementStep();
                    this.scrollToTop();
                })
                .catch((error) => {
                    console.error(error);
                    this.submitting = false;
                });
        },

        handlePlaceUpdated(place) {
            if (typeof place.formatted_address != 'undefined') {
                this.setCustomerAddress(place.formatted_address)
            }
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },
    },
    watch: {
        step() {
            this.scrollToTop();
        }
    },
    created() {
        this.setBrand(window.brand);

        if (this.queryParams.get('short_booking')) {
            this.enableShortOnlineServiceBooking();
        }

        this.initializeLocation({
            getAddressInfo: true,
            getPhoneInfo: true,
        }).then(() => {
            this.collectLocationData();
        });
    },
    mounted() {
        this.checkIfAuthenticated()

        if (this.shortOnlineServiceBooking) {
            this.collectUserVehicleData();
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/online-service-booking/OnlineServiceBooking.vue